import React from 'react'

function CardServices({
  title = 'Default Title',
  description,
  backgroundColor,
  colorTitle,
  colorContent,
  boxShadow,
  boxShadowDark,
  width,
  height,
  className,
  img,
  srcImg,
  altImg,
}) {
  return (
    <div
      data-aos="fade-up"
      className={`card-services cards text-center ${boxShadow ? 'box-shadow' : ''} 
      ${boxShadowDark ? 'box-shadow-dark' : ''} ${className}`}
      style={{ backgroundColor, height, width }}
    >
      {img && (
        <div className="img-hg img-80-hg mg__bottom-15">
          <img src={srcImg} alt={altImg} />
        </div>
      )}
      <h3 className="card-services__title" style={{ color: colorTitle }}>
        {title}
      </h3>
      <p className="card-services__content" style={{ color: colorContent }}>
        {description}
      </p>
    </div>
  )
}

export default CardServices
